module.exports = __webpack_public_path__ + "img/375_news_main_img4.047a5d36.png";